/**
 * Impersonation Banner
 * Shows when admin is viewing as a user
 */
import React from 'react';
import toast from '../utils/toast';

import {
  Warning,
  X
} from '@phosphor-icons/react';
const ImpersonationBanner = () => {
  const isImpersonating = localStorage.getItem('impersonation_active') === 'true';
  const impersonatedUserName = localStorage.getItem('impersonated_user_name');
  const impersonatedUserEmail = localStorage.getItem('impersonated_user_email');

  if (!isImpersonating) {
    return null;
  }

  const handleExitImpersonation = () => {
    // Restore admin token
    const adminToken = localStorage.getItem('impersonation_admin_token');
    if (adminToken) {
      localStorage.setItem('admin_token', adminToken);
    }
    
    // Clear impersonation data
    localStorage.removeItem('impersonation_admin_token');
    localStorage.removeItem('impersonation_active');
    localStorage.removeItem('impersonated_user_name');
    localStorage.removeItem('impersonated_user_email');
    localStorage.removeItem('token');
    
    toast.success('Exited impersonation mode');
    
    // Redirect back to admin panel
    window.location.href = '/admin/users';
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-orange-600 to-red-600 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Warning size={20} />
          <div>
            <p className="font-semibold">
              ⚠️ Admin Impersonation Mode
            </p>
            <p className="text-sm text-white/90">
              Viewing as: <span className="font-medium">{impersonatedUserName}</span> ({impersonatedUserEmail})
            </p>
          </div>
        </div>
        <button
          onClick={handleExitImpersonation}
          className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors flex items-center gap-2 font-semibold"
        >
          <X size={18} />
          Exit Impersonation
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
